// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"theme__wrapper__7HZHVXrj","dialog":"theme__dialog__3_B80PFy","active":"theme__active__1TPk7TCu","small":"theme__small__1zROX65T","normal":"theme__normal__2JTt7JRZ","fullscreen":"theme__fullscreen__2R9KMQL1","large":"theme__large__3bgiF24x","title":"theme__title__39qPXgfe","body":"theme__body__WEcfIkxZ","navigation":"theme__navigation__14-mGN9Y","button":"theme__button__1m4UfHfZ"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-toolbox/lib/dialog/theme.css
// module id = 955
// module chunks = 0